import React from 'react';
import './styles/dashboardcard.css'; // Ensure you have a corresponding CSS file for styling

import { IconContext } from 'react-icons';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const formatNumber = (num) => {
  const n = parseFloat(num);
  if (isNaN(n)) return { display: '-', shortened: false };

  if (n >= 1_000_000_000) return { display: Math.floor(n / 1_000_000_000 * 100) / 100 + 'B', shortened: true };
  if (n >= 1_000_000) return { display: Math.floor(n / 1_000_000 * 100) / 100 + 'M', shortened: true };
  // if (n >= 1_000) return { display: Math.floor(n / 1_000 * 100) / 100 + 'K', shortened: true };

  return { display: n.toString(), shortened: false };
};


const DashboardCard = ({
  count,
  label,
  name,
  icon: Icon,
  iconColor,
  table,
  headingColor,
  labelColor,
  changeColor,
  suffix,
  loading = false,
  accentColor,

}) => {

  const formatted = formatNumber(count);
  return (
    <div
      className={`dashboard-card ${name}${accentColor ? ' dashboard-card-accented' : ''}`}
      style={accentColor ? { '--dashboard-card-accent': accentColor } : undefined}
    >
      <div className="dashboard-card-content">
        <div className='dashboardcard-icon-container'>
          <IconContext.Provider value={{ color: iconColor, size: "3em" }}> {/* Adjust the size as needed */}

            <Icon className='dashboardcard-icon' /> {/* Dynamically render the icon */}

          </IconContext.Provider>
        </div>
        <div className="dashboard-card-info">
          {loading ? (
            <div className="dashboard-card-value-loading" aria-label={`Loading ${label}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          ) : formatted.shortened ? (
            <Tippy content={`${count}${suffix ?? ''}`} className="custom-tooltip">
              <h1 style={{ color: headingColor }}>{formatted.display}{suffix}</h1>
            </Tippy>
          ) : (
            <h1 style={{ color: headingColor }}>{formatted.display}{suffix}</h1>
          )}
          <div className="dashboard-card-label" style={{ color: labelColor }}>
            {label}
          </div>
        </div>
        <div className="dashboard-card-change">
          <span style={{ color: changeColor }}>{table}</span>
        </div>

      </div>
    </div>
  );
};

export default DashboardCard;
